import React, { Component } from 'react';

import 'css/Header.css';


class Header extends Component {
    render() {
        return (
            <header className="hide-for-small-only">
        
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js